interface entry {
  target: HTMLElement;
  boundingClientRect: {
    top: number;
    bottom: number;
  };
}
interface options {
  root: HTMLElement | null;
  rootMargin: string;
  threshold: number;
}
interface addOptions {
  type: string;
  observationTarget: string;
  changeTarget: string | null;
  addClass?: string | null;
  changeTargetAddClass?: string | null;
  bodyAddClass: boolean;
  addFunc?: (entry: entry, type?: 'in' | 'out', changeElement?:HTMLElement ) => void | null;
}

export function intersectionObserver(optionsObj: options, addOptinsObj: addOptions): void {
  const observationTarget = document.querySelectorAll(addOptinsObj.observationTarget);
  let changeElement: HTMLElement;
  let bodyEl: HTMLElement;
  if (addOptinsObj.changeTarget) {
    changeElement = document.querySelector(addOptinsObj.changeTarget);
  }
  if (addOptinsObj.bodyAddClass) {
    bodyEl = document.querySelector('body');
  }
  const crossingTarget = function (entries) {
    Array.prototype.forEach.call(entries, (entry) => {
      if (addOptinsObj.type === 'inOutLarge') {
        let flag = false;
        const timing = entry.target.dataset.intersectionTiming || 0;
        setTimeout(() => {
          if (!entry.isIntersecting && entry.boundingClientRect.y < 0) {
            changeElement.classList.add(addOptinsObj.changeTargetAddClass);
            if (!flag) {
              flag = true;
            }
          } else if (!entry.isIntersecting && entry.boundingClientRect.y > 0 && flag) {
            changeElement.classList.add(addOptinsObj.changeTargetAddClass);
          } else {
            changeElement.classList.remove(addOptinsObj.changeTargetAddClass);
            if (!flag) {
              flag = true;
            }
          }
        }, timing);
      }
      if (addOptinsObj.type === 'inBottom') {
        const timing = entry.target.dataset.intersectionTiming || 0;
        setTimeout(() => {
          if (entry.intersectionRatio > 0 && addOptinsObj.changeTargetAddClass) {
            // intersectionRatio entry が交差しているか
            changeElement.classList.remove(addOptinsObj.changeTargetAddClass);
            if (addOptinsObj.addFunc) {
              addOptinsObj.addFunc(entry, 'out', changeElement);
            }
          } else if (entry.boundingClientRect.top < 0 && addOptinsObj.changeTargetAddClass) {
            changeElement.classList.add(addOptinsObj.changeTargetAddClass);
            if (addOptinsObj.addFunc) {
              addOptinsObj.addFunc(entry, 'in', changeElement);
            }
          }
        }, timing);
      } else if (addOptinsObj.type === 'inTop') {
        const timing = entry.target.dataset.intersectionTiming || 0;
        setTimeout(() => {
          if (entry.intersectionRatio <= 0 && entry.boundingClientRect.top > 0 && addOptinsObj.changeTargetAddClass) {
            changeElement.classList.remove(addOptinsObj.changeTargetAddClass);
            if (addOptinsObj.addFunc) {
              addOptinsObj.addFunc(entry, 'out', changeElement);
            }
          } else if (addOptinsObj.changeTargetAddClass) {
            changeElement.classList.add(addOptinsObj.changeTargetAddClass);
            if (addOptinsObj.addFunc) {
              addOptinsObj.addFunc(entry, 'in', changeElement);
            }
          }
        }, timing);
      } else if (addOptinsObj.type === 'through' || addOptinsObj.type === 'inOut') {
        if (entry.isIntersecting) {
          const timing = entry.target.dataset.intersectionTiming || 0;
          if (!entry.target.classList.contains('is-through')) {
            setTimeout(() => {
              entry.target.dataset.onTheScreen = entry.isIntersecting;
              if (addOptinsObj.addClass) {
                entry.target.classList.add(addOptinsObj.addClass);
              }
              if (addOptinsObj.changeTargetAddClass) {
                changeElement.classList.add(addOptinsObj.changeTargetAddClass);
              }
              if (addOptinsObj.type === 'through') {
                entry.target.classList.add('is-through');
              }
              if (addOptinsObj.bodyAddClass) {
                onBodyAddClass(entry, true);
              }
              if (addOptinsObj.addFunc) {
                addOptinsObj.addFunc(entry, 'in', changeElement);
              }
            }, timing);
          }
        } else {
          entry.target.dataset.onTheScreen = entry.isIntersecting;
          if (addOptinsObj.type === 'inOut') {
            if (addOptinsObj.addClass) {
              entry.target.classList.remove(addOptinsObj.addClass);
            }
            if (addOptinsObj.changeTargetAddClass) {
              changeElement.classList.remove(addOptinsObj.changeTargetAddClass);
            }
            if (addOptinsObj.bodyAddClass) {
              onBodyAddClass(entry, false);
            }
            if (addOptinsObj.addFunc) {
              addOptinsObj.addFunc(entry, 'out', changeElement);
            }
          }
        }
      }
    });
  };

  const onBodyAddClass = (el, bool) => {
    const className = el.target.dataset.intersectionBodyAddClass;
    if (bool) {
      bodyEl.classList.add(className);
    } else {
      bodyEl.classList.remove(className);
    }
  };

  const options = {
    root: optionsObj.root,
    rootMargin: optionsObj.rootMargin,
    threshold: optionsObj.threshold,
  };

  const observer = new IntersectionObserver(crossingTarget, options);

  if (observationTarget.length !== 0)
    Array.prototype.forEach.call(observationTarget, function (value: HTMLElement) {
      observer.observe(value);
    });
}
